import { Button, Card, Flex, Text, Title } from '@wyz/ui';
import { IServiceQuoteCart } from '~/purchase/types';

import { Trans, useLocale } from '~/common/context';

type Props = {
  services: IServiceQuoteCart['services'];
  onNext: () => void;
  vatPercentage: number;
  totalTaxIncl: number;
  totalTaxExcl: number;
  totalVatPrice: number;
  totalDiscount: number;
};

function TotalSection({
  services,
  onNext,
  vatPercentage,
  totalTaxIncl,
  totalTaxExcl,
  totalVatPrice,
  totalDiscount,
}: Props) {
  const locale = useLocale();

  const currency = 'EUR';
  return (
    <Card>
      <Card.Body>
        <Title heading='lg' weight='bold' color='secondary' wrap>
          <Trans i18nKey={'app.purchase.service_quote.cart.summary'} />
        </Title>
        {services.map((service, index) => {
          const price = locale.formatters.money(service.priceTaxIncl, {
            currency: currency,
          });
          return (
            <Flex
              key={service.id}
              className='bg-neutral-grey-1 py-2 px-3'
              justifyContent='between'
            >
              <Text heading='xs' weight='semi-bold' color='secondary'>
                {service.serviceName}
              </Text>
              <Text
                id={`service-price-tax-included-group-${index}`}
                heading='sm'
                weight='semi-bold'
                color={service.manualDiscount ? 'warning' : 'secondary'}
              >
                {service.manualDiscount && service.basePriceTaxIncl > 0 ? (
                  <Trans
                    i18nKey='app.purchase.quote_cart_page.price_edit.price_discount'
                    values={{
                      price,
                      discountPercentage: -service.discountPercentage,
                    }}
                  />
                ) : (
                  price
                )}
              </Text>
            </Flex>
          );
        })}
        <div className='bg-neutral-grey-2 py-2 px-3'>
          <div className=' space-y-2'>
            <Flex justifyContent='between' alignItems='center'>
              <Text heading='xs' weight='semi-bold' color='secondary'>
                <Trans i18nKey='app.purchase.quote_cart_page.total_section.sub_total' />
              </Text>
              <Text
                id={`total-tax-excl-group`}
                heading='xs'
                weight='semi-bold'
                color='secondary'
              >
                {locale.formatters.money(totalTaxExcl, {
                  currency: currency,
                })}
              </Text>
            </Flex>
            <Flex justifyContent='between' alignItems='center'>
              <Text heading='xs' weight='semi-bold' color='secondary'>
                <Trans i18nKey='app.common.total_discount' />
              </Text>
              <Text
                id={`total-discount-group`}
                heading='xs'
                weight='semi-bold'
                color='secondary'
              >
                {locale.formatters.money(totalDiscount, {
                  currency: currency,
                })}
              </Text>
            </Flex>

            <Flex justifyContent='between' alignItems='center'>
              <Text heading='xs' weight='semi-bold' color='secondary'>
                <Trans
                  i18nKey='app.purchase.quote_cart_page.total_section.vat'
                  values={{
                    value: vatPercentage,
                  }}
                />
              </Text>
              <Text
                id={`vat-price-group`}
                heading='xs'
                weight='semi-bold'
                color='secondary'
              >
                {locale.formatters.money(totalVatPrice, {
                  currency: currency,
                })}
              </Text>
            </Flex>
          </div>
          <div className='border border-1 my-2'></div>
          <Flex justifyContent='between' alignItems='center'>
            <Text heading='xs' weight='bold' color='tertiary-bold'>
              <Trans i18nKey='app.purchase.quote_cart_page.total_section.total' />
            </Text>
            <Text
              id={`total-group`}
              heading='normal'
              weight='bold'
              color='tertiary-bold'
            >
              {locale.formatters.money(totalTaxIncl, {
                currency: currency,
              })}
            </Text>
          </Flex>
        </div>
        <Button id='next' variant='primary' onClick={onNext} fullWidth>
          <Trans i18nKey='app.purchase.quote_cart_page.total_section.next' />
        </Button>
      </Card.Body>
    </Card>
  );
}

export default TotalSection;
